import "./index.css";
import React from "react";
import { Amplify } from "aws-amplify";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import { CookiesProvider as GlobalCookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AuthProvider from "./contexts/AuthProvider";
import CookieProvider from "./contexts/CookieProvider";
import App from "./App";
import StorageProvider from "./contexts/StorageProvider";
import { store, persistor } from "./store";
import { amplifyConfig } from "./env";
import moment from "moment";
import localization from "moment/locale/it";
import { PersistGate } from "redux-persist/integration/react";

moment.updateLocale("it", localization);
Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GlobalCookiesProvider>
          <BrowserRouter>
            <StorageProvider>
              <CookieProvider>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </CookieProvider>
            </StorageProvider>
          </BrowserRouter>
        </GlobalCookiesProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
